export default "__VITE_ASSET__BCzM72_Y__";